import { CustomerPaymentTypeEnum } from 'graphQL/hatostore/generate/operations'
import { PaymentTypeEnum } from 'graphQL/dinein/generate/operations'

const baseUrl: string = window.location.origin.toString()
const fullUrl: string = window.location.href

const checkPathIsOpen = (path: string) => {
  return fullUrl.includes(`${baseUrl}${path}`)
}

export const checkDineInIsOpen = () => checkPathIsOpen(`${process.env.REACT_APP_DINE_IN_ABSOLUTE_PATH}`)
export const checkBuffetIsOpen = () => checkPathIsOpen(`${process.env.REACT_APP_BUFFET_ABSOLUTE_PATH}`)

export const convertTypeCustomerPaymentTypeEnumToPaymentTypeEnum = (
  paymentMethod: CustomerPaymentTypeEnum
): PaymentTypeEnum => {
  switch (paymentMethod) {
    // Manual specific convert for match directly value of enum for avoid issue miss matching key from codegen that auto capitalize value to key.
    // ISSUE cases:
    // - SCBPromptPay -> ScbPromptPay
    // - KBankThaiQR -> KBankThaiQr
    // - There is no type CashOnDelivery in PaymentTypeEnum
    case CustomerPaymentTypeEnum.BankTransfer:
      return PaymentTypeEnum.BankTransfer
    case CustomerPaymentTypeEnum.KBankThaiQr:
      return PaymentTypeEnum.KBankThaiQr
    case CustomerPaymentTypeEnum.KPaymentKPlusNumber:
      return PaymentTypeEnum.KPaymentKPlusNumber
    case CustomerPaymentTypeEnum.KPaymentPromptPayNumber:
      return PaymentTypeEnum.KPaymentPromptPayNumber
    case CustomerPaymentTypeEnum.LinePay:
      return PaymentTypeEnum.LinePay
    case CustomerPaymentTypeEnum.OmiseCreditCard:
      return PaymentTypeEnum.OmiseCreditCard
    case CustomerPaymentTypeEnum.OmisePromptPay:
      return PaymentTypeEnum.OmisePromptPay
    case CustomerPaymentTypeEnum.OmiseTrueMoneyWallet:
      return PaymentTypeEnum.OmiseTrueMoneyWallet
    case CustomerPaymentTypeEnum.ScbPromptPay:
      return PaymentTypeEnum.ScbPromptPay
    default:
      return PaymentTypeEnum.None
  }
}
